<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog key="basic" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="main-top-group">
	<!--  	   	 	 -->
	<!-- TOP SECTION -->
	<!-- 			 -->
	<div class="column-group">
		<div class="column1">
			<!--  	   	    -->
			<!-- Staff Name -->
			<!-- 		    -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Edited by Staff</label>
				</div>

				<div style="margin-left: 10px">
					<label style="color: #d19a02">{{ rAdminName }}</label>
				</div>
			</div>

			<!--  	   	            -->
			<!-- Group Action Option Selector  -->
			<!-- 		            -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Prompt Type</label>
				</div>

				<div style="margin-left: 10px; width: 300px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select class="form-control" name="SelectedPromptTypeIDSelector" style="font-size: smaller" [(ngModel)]="SelectedPromptTypeID">
						<option *ngFor="let r of lstPromptType" [ngValue]="r.ID">
							{{ r.Desc }}
						</option>
					</select>
				</div>
			</div>

			<!-- 		    -->
			<!-- IncidentDT -->
			<!-- 		    -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Date / Time</label>
				</div>

				<div style="margin-left: 10px">
					<p-calendar
						[style]="{ width: '100%' }"
						[inputStyle]="{ width: '100%' }"
						[(ngModel)]="rIncidentDT"
						[showTime]="true"
						hourFormat="12"
						showIcon="true"
						inputId="incidentdt"
					></p-calendar>
				</div>
			</div>

			<!--  	   	            -->
			<!-- Infraction Selector  -->
			<!-- 		            -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Infraction</label>
				</div>

				<div style="margin-left: 10px; width: 300px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedInfractionSelector"
						style="font-size: smaller"
						[(ngModel)]="SelectedInfraction"
						(ngModelChange)="onInfractionChange($event)"
					>
						<option
							*ngFor="let r of lstInfractionItems"
							[ngValue]="r"
							[ngClass]="{
								'sel-ip-school': r.SchoolID >= 1,
								'sel-ip-sys': r.SchoolID < 1
							}"
						>
							{{ r.InfractionDesc }}
						</option>
					</select>
				</div>
			</div>

			<!--  	   	            -->
			<!-- Penalty Selector  -->
			<!-- 		            -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Action</label>
				</div>

				<div style="margin-left: 10px; width: 300px">
					<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
					<select
						class="form-control"
						name="SelectedPenaltySelector"
						style="font-size: smaller"
						[(ngModel)]="SelectedPenalty"
						(ngModelChange)="onPenaltyChange($event)"
					>
						<option
							*ngFor="let r of lstPenaltyItems"
							[ngValue]="r"
							[ngClass]="{
								'sel-ip-school': r.SchoolID >= 1 && r.isSusp == false,
								'sel-ip-school-susp': r.SchoolID >= 1 && r.isSusp == true,
								'sel-ip-sys': r.SchoolID < 1 && r.isSusp == false,
								'sel-ip-sys-susp': r.SchoolID < 1 && r.isSusp == true
							}"
						>
							{{ r.PenaltyDesc }}
						</option>
					</select>
				</div>
			</div>

			<!--  	   	    -->
			<!-- Alert Info -->
			<!-- 		    -->
			<div class="column-item">
				<div class="column-item-alert" [style.display]="SelectedPenalty.AlertID > 0 ? 'flex' : 'none'">
					<!--  	   	        -->
					<!-- Continue Alert -->
					<!-- 		     	-->
					<div>
						<label class="column-item-label">Alert</label>
					</div>

					<div style="margin-left: 10px">
						<p-checkbox [(ngModel)]="rContinueAlert" [binary]="true"></p-checkbox>
					</div>

					<!--  	   	    -->
					<!-- Play Sound -->
					<!-- 		   	-->
					<div style="margin-left: 10px">
						<button
							class="btn btn-primary btn-sm"
							style="margin-left: 5px"
							(click)="onPlay()"
							[disabled]="isBusy == true || SelectedPenalty.SoundData.length == 0"
						>
							Play
						</button>
						<button
							class="btn btn-primary btn-sm"
							style="margin-left: 5px"
							(click)="onStop()"
							[disabled]="isBusy == true || SelectedPenalty.SoundData.length == 0"
						>
							Stop
						</button>
					</div>

					<!--  	   	    -->
					<!-- Alert Desc -->
					<!-- 		   	-->
					<div style="margin-left: 10px">
						<label style="color: blue">{{ SelectedPenalty.AlertDesc }}</label>
					</div>
				</div>
			</div>

			<!--  	   	   -->
			<!-- Susp Info -->
			<!-- 		   -->
			<div style="margin-top: 25px" [style.display]="risSusp == true ? 'block' : 'none'">
				<div style="background-color: #dadada">
					<!-- 	     				 -->
					<!-- Date Range / School Day -->
					<!-- 	     				 -->
					<div class="column-item">
						<div>
							<label class="column-item-label">Range/Day</label>
						</div>

						<div style="margin-left: 10px">
							<p-radioButton
								name="radio1"
								value="1"
								label="By Date Range"
								[(ngModel)]="selectedRadioValue"
								(onClick)="onRadioChange()"
							></p-radioButton>
						</div>

						<div style="margin-left: 10px">
							<p-radioButton
								name="radio1"
								value="2"
								label="By School Days"
								[(ngModel)]="selectedRadioValue"
								(onClick)="onRadioChange()"
							></p-radioButton>
						</div>
					</div>
				</div>

				<!--  	   	                        -->
				<!-- Radio 1 - Date Range Selection -->
				<!-- 		             			-->
				<div [style.display]="selectedRadioValue == '1' ? 'block' : 'none'">
					<!--  	   -->
					<!-- #Days -->
					<!-- 	   -->
					<div class="column-item">
						<div>
							<label class="column-item-label">Suspension Days</label>
						</div>

						<div style="margin-left: 10px">
							<label style="color: blue; width: 35px">{{ rSuspNbrDays1 }}</label>
						</div>

						<div style="margin-left: 25px">
							<label>Min Days</label>
						</div>

						<div style="margin-left: 10px">
							<label style="color: blue">{{ rMinDurationDayCount }}</label>
						</div>

						<div style="margin-left: 15px">
							<label>Max Days</label>
						</div>

						<div style="margin-left: 10px">
							<label style="color: blue">{{ rMaxDurationDayCount }}</label>
						</div>
					</div>

					<!-- 		    -->
					<!-- Start Date -->
					<!-- 		    -->
					<div class="column-item">
						<div>
							<label class="column-item-label">Start Date</label>
						</div>

						<div style="margin-left: 10px">
							<p-calendar
								[style]="{ width: '100%' }"
								[inputStyle]="{ width: '100%' }"
								[(ngModel)]="rStartDate1"
								(ngModelChange)="onStartDate1Change($event)"
								[showTime]="false"
								hourFormat="12"
								showIcon="true"
								inputId="StartDate1"
							></p-calendar>
						</div>
					</div>

					<!-- 	      -->
					<!-- End Date -->
					<!-- 	      -->
					<div class="column-item">
						<div>
							<label class="column-item-label">End Date</label>
						</div>

						<div style="margin-left: 10px">
							<p-calendar
								[style]="{ width: '100%' }"
								[inputStyle]="{ width: '100%' }"
								[(ngModel)]="rEndDate1"
								(ngModelChange)="onEndDate1Change($event)"
								[showTime]="false"
								hourFormat="12"
								showIcon="true"
								inputId="EndDate1"
							></p-calendar>
						</div>
					</div>
				</div>

				<!--  	   	                       -->
				<!-- Radio 2 -School Day Selection -->
				<!-- 		             		   -->
				<div [style.display]="selectedRadioValue == '2' ? 'block' : 'none'">
					<!--  	   -->
					<!-- #Days -->
					<!-- 	   -->
					<div class="column-item">
						<div>
							<label class="column-item-label">Suspension Days</label>
						</div>

						<div style="margin-left: 10px">
							<input
								type="text"
								pInputText
								[(ngModel)]="rSuspNbrDays2"
								(ngModelChange)="onSuspNbrDays2($event)"
								maxlength="4"
								style="width: 35px"
							/>
						</div>

						<div style="margin-left: 25px">
							<label>Min Days</label>
						</div>

						<div style="margin-left: 10px">
							<label style="color: blue">{{ rMinDurationDayCount }}</label>
						</div>

						<div style="margin-left: 15px">
							<label>Max Days</label>
						</div>

						<div style="margin-left: 10px">
							<label style="color: blue">{{ rMaxDurationDayCount }}</label>
						</div>
					</div>

					<!-- 		    -->
					<!-- Start Date -->
					<!-- 		    -->
					<div class="column-item">
						<div>
							<label class="column-item-label">Start Date</label>
						</div>

						<div style="margin-left: 10px">
							<p-calendar
								[style]="{ width: '100%' }"
								[inputStyle]="{ width: '100%' }"
								[(ngModel)]="rStartDate2"
								(ngModelChange)="onStartDate2Change($event)"
								[showTime]="false"
								hourFormat="12"
								showIcon="true"
								inputId="StartDate2"
							></p-calendar>
						</div>
					</div>

					<!-- 	      -->
					<!-- End Date -->
					<!-- 	      -->
					<div class="column-item">
						<div>
							<label class="column-item-label">End Date</label>
						</div>

						<div style="margin-left: 10px">
							<p-calendar
								[style]="{ width: '100%' }"
								[inputStyle]="{ width: '100%' }"
								[(ngModel)]="rEndDate2"
								[disabled]="true"
								(ngModelChange)="onEndDate2Change($event)"
								[showTime]="false"
								hourFormat="12"
								showIcon="true"
								inputId="EndDate2"
							></p-calendar>
						</div>
					</div>
				</div>
			</div>

			<!--  	   	              -->
			<!-- Portal Notifications -->
			<!-- 		              -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Send Notifications:</label>
				</div>

				<div style="margin-left: 10px; display: grid; align-items: center; grid-template-columns: auto auto auto auto auto auto; grid-column-gap: 5px">
					<input type="checkbox" class="CHK NoMargin" id="ParentPortalSendNotification" [(ngModel)]="ParentPortalSendNotification" />
					<label class="NoMargin" for="ParentPortalSendNotification">Parent Portal</label>

					<input
						type="checkbox"
						class="CHK NoMargin"
						style="margin-left: 15px"
						id="StudentPortalSendNotification"
						[(ngModel)]="StudentPortalSendNotification"
					/>
					<label class="NoMargin" for="StudentPortalSendNotification">Student Portal</label>

					<input
						type="checkbox"
						class="CHK NoMargin"
						style="margin-left: 15px"
						id="StaffPortalSendNotification"
						[(ngModel)]="StaffPortalSendNotification"
					/>
					<label class="NoMargin" for="StaffPortalSendNotification">Staff Portal</label>
				</div>
			</div>
		</div>
	</div>
</div>

<!--				-->
<!-- Error Message  -->
<!--				-->
<div class="error-group" [style.display]="ErrorMessage.length == 0 ? 'none' : 'block'">
	<div class="error-div">
		<label class="error-message">{{ ErrorMessage }}</label>
	</div>
</div>

<!--Update on Parent-->
